import { useMemo } from "react";

import { ChangeMetric } from "@similarweb/ui-components";

import type { IMarketSizeText } from "../consts";

type ScoreText = IMarketSizeText["score"];

import { Loader } from "./Loader";

interface IScore {
    isLoading: boolean;
    scoreData: string;
    country: number;
    text: ScoreText;
}

export const Score = ({ isLoading = true, scoreData, country, text }: IScore) => {
    const changeProps = useMemo(() => {
        return { value: scoreData, unsigned: true };
    }, [scoreData]);

    const countryIconProps = useMemo(() => {
        return {
            code: country,
        };
    }, [country]);

    const labelProps = {
        displayValue: text.label,
    };

    const infoTooltipProps = {
        info: text.tooltip,
    };

    if (isLoading) {
        return <Loader />;
    }

    return (
        <ChangeMetric
            changeProps={changeProps}
            labelProps={labelProps}
            infoTooltipProps={infoTooltipProps}
            countryIconProps={countryIconProps}
        />
    );
};
